import React from 'react';

export const getOtpSteps = (FormattedText, injectedDates) => [
    {
        id: '01',
        text: <FormattedText value="otpCode-transferOTPFirstStep" />,
    },
    {
        id: '02',
        text: <FormattedText value="otpCode-transferOTPSecondStep" injectedStrings={injectedDates} />,
    },
    {
        id: '03',
        text: <FormattedText value="otpCode-transferOTPThirdStepModal" />,
    },
];
